// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-download .v-btn + .v-btn {\n  margin-left: 5px;\n}\n@media all and (min-width: 991px) {\n.btn-container {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n.main-button-bottom {\n  margin-top: 30px;\n}\n.md-field {\n  max-width: 300px;\n}\nul {\n  margin: 0 0 10px;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
